module.exports = __webpack_public_path__ + "static/media/icon-arrow-blue-up.1b521b5e.svg";